if (!customElements.get('blog-hero')) {
  class BlogHeroSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.swiperContainer = this.querySelector('.swiper');
    }
  
    connectedCallback() {
      this.initializeSwiper();
    }
  
    initializeSwiper() {
      this.swiper = new Swiper(this.swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets'
        },
        autoplay: false,
        effect: 'slide',
        speed: 300,
        grabCursor: true,
        watchOverflow: true,
        on: {
          init: () => {
            this.dispatchEvent(new CustomEvent('swiper:init', { detail: { swiper: this.swiper } }));
          }
        }
      });
    }
  }
  
  // Register the web component
  customElements.define('blog-hero', BlogHeroSlider);
}